import styles from "./pricingAndCredits.module.css";
import { PricingIllustration } from "@/assets/svg";

export const PricingAndCredits = () => {
  return (
    <section id="pricing" className={styles.pricingSection}>
      <div className={styles.pricingInner}>
        <h2 className={styles.heading}>
          Pricing <span className={styles.andHighlight}>And</span>{" "}
          <span className={styles.creditsHighlight}>Credits</span>
        </h2>

        <div className={styles.contentRow}>
          <div className={styles.illustrationCol} aria-hidden="true">
            <PricingIllustration />
          </div>

          <div className={styles.cardsCol}>
            <div className={styles.savingsCard}>
              <p className={styles.savingsPercentage}>70%</p>
              <p className={styles.savingsLabel}>Of Savings</p>
              <p className={styles.savingsText}>
                We share in the savings only when we successfully lower your property value.
              </p>
            </div>

            <div className={styles.pricingCard}>
              <div className={styles.priceRow}>
                <span className={styles.priceAmount}>$49</span>
                <span className={styles.priceNote}>Payable Now</span>
              </div>

              <h3 className={styles.pricingTitle}>
                Annual property and
                <br />
                community monitoring
              </h3>

              <div className={styles.divider} />

              <p className={styles.pricingDescription}>
                We monitor your property value and surrounding community data throughout the year so
                you are prepared when it is time to protest your property taxes.
              </p>

              <div className={styles.noticeBox}>
                <p className={styles.noticeHeading}>In Texas, property taxes reset every year.</p>
                <p className={styles.noticeText}>
                  To help keep your tax burden from increasing, a new protest is needed each year.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
